import { NgModule } from '@angular/core'

import { RouterModule,
         Routes } from '@angular/router'

import { AppContainerComponent, 
         PathNotFoundComponent } from './_shared/index'


// CORE
import { LoginComponent } from './auth/login/login.component'
import { CookieConsentPageComponent } from './auth/cookie-consent-page/cookie-consent-page.component'
import { TermsPageComponent } from './terms-page/terms-page.component'
import { PrivacyPageComponent } from './privacy-page/privacy-page.component'
// import { ThankYouPageComponent } from './thank-you-page/thank-you-page.component'
// import { ContactPageComponent } from './contact-page/contact-page.component'


// CUSTOM: LCP
import { AboutComponent } from './about/about.component'
import { ContactComponent } from './contact/contact.component'
import { ProjectComponent } from './project/project.component'
import { ProjectsComponent } from './projects/projects.component'
import { TeamComponent } from './team/team.component'
import { HomepageComponent } from './homepage/homepage.component'
import { HomepageV1Component } from './homepage-v1/homepage-v1.component'

// import { DeleteOrderPopupComponent } from  './delete-order-popup/delete-order-popup.component'
// import { DeleteServicePopupComponent } from './delete-service-popup/delete-service-popup.component'
import { DeleteUserPopupComponent } from './delete-user-popup/delete-user-popup.component'


// CUSTOM: OAK PARK
// import { HomeComponent } from './home/home.component'
// import { RequestQuotePageComponent } from './request-quote-page/request-quote-page.component'
// import { PaymentSubmittedPageComponent } from './payment-submitted-page/payment-submitted-page.component'
// import { OrderSubmittedPageComponent } from './order-submitted-page/order-submitted-page.component'
// import { OrderInvoicePageComponent } from './order-invoice-page/order-invoice-page.component'
// import { ConfirmOrderPopupComponent } from './confirm-order-popup/confirm-order-popup.component'

import { RepoComponent } from './repo/repo.component'
import { CookieConsentPopupComponent } from './auth/cookie-consent-popup/cookie-consent-popup.component'
import { ServicesComponent } from './services/services.component'
import { ServiceComponent } from './service/service.component'




const ROUTES: Routes = [

  { path: '',
    component: AppContainerComponent,
    // data: { title: 'welcome' },
    children: [


      { path: '', pathMatch: 'full', component: HomepageComponent},

      { path: 'login',
        component: LoginComponent,
        data: { title: 'login' } 
      },
    
      { path: 'cookies',
        component: CookieConsentPageComponent,
        data: { title: 'cookies' }
      },
      // { path: 'home', component: HomepageComponent },

      // { path: 'about', component: AboutComponent },
      // { path: 'case-studies', component: CaseStudiesComponent },
      // { path: 'contact', component: ContactComponent },
      // { path: 'projects', component: ProjectsComponent },
      // { path: 'projects/:slug', component: ProjectComponent },

      { path: 'team', component: TeamComponent },
      { path: 'about', component: AboutComponent },
      { path: 'contact', component: ContactComponent },
      { path: 'work', component: ProjectsComponent },
      { path: 'work/:slug', component: ProjectComponent },


      // { path: '',
      //   component: HomeComponent,
      //   data: { title: 'Welcome' },
      // },


      { path: 'demo/home-v1', component: HomepageV1Component },


      // { path: 'request-quote',
      //   component: RequestQuotePageComponent,
      //   data: { title: 'Request a Quote' }
      // },

      // { path: 'request-quote/thank-you',
      //   component: ThankYouPageComponent,
      //   data: { title: 'Thank you' }
      // },

      // { path: 'payment-submitted',
      //   component: PaymentSubmittedPageComponent,
      //   data: { title: 'Payment Submitted' }
      // },

      // { path: 'order-submitted',
      //   component: OrderSubmittedPageComponent,
      //   data: { title: 'Order Sbmitted' }
      // },

      { path: 'terms',
        component: TermsPageComponent,
        data: { title: 'Terms' }
      },

      { path: 'privacy',
        component: PrivacyPageComponent,
        data: { title: 'Privacy' }
      },

      // { path: 'orders/:obfuscated_id',
      //   component: OrderInvoicePageComponent,
      //   data: { title: 'Invoice' }
      // },


      { path: 'repo', 
        component: RepoComponent,
        data: { title: 'Software Repository' }
      },

      // { path: 'services', 
      //   component: ServicesComponent,
      //   data: { title: 'services' } 
      // },

      { path: 'services', 
        children: [
          { path: '',
            component: ServicesComponent,
            data: { title: 'services' } 
          },
          { path: ':service',
            component: ServiceComponent,
          },
        ]
      
      }
    ]
  },


  { path: 'demo/degenkolb-2022',
    loadChildren : () => import('./book/book.module').then(m => m.BookModule)},


  { path: 'admin',
    loadChildren: () => import(`./admin/admin.module`).then(m => m.AdminModule)
  },

  // { path: 'login',
  //   component: LoginComponent,
  //   data: { title: 'login' } 
  // },

  // { path: 'cookies',
  //   component: CookieConsentPageComponent,
  //   data: { title: 'cookies' }
  // },


    // POPUPS
  
    { outlet: 'p',
      path: 'login',
      component: LoginComponent,
      data: { title: 'login' }
    },

    // { outlet: 'p',
    //   path: 'confirm',
    //   component: ConfirmOrderPopupComponent,
    //   data: { title: 'Confirm Order' }
    // },

    { outlet: 'p',
      path: 'cookies',
      component: CookieConsentPopupComponent,
      data: { title: 'Cookies' }
    },

    // { outlet: 'p',
    //   path: 'delete-order',
    //   component: DeleteOrderPopupComponent,
    //   data: { title: 'Delete Order' }
    // },

    // { outlet: 'p',
    //   path: 'delete-service',
    //   component: DeleteServicePopupComponent,
    //   data: { title: 'Delete Order' }
    // },

    { outlet: 'p',
      path: 'delete-user',
      component: DeleteUserPopupComponent,
      data: { title: 'Delete User' }
    },


  { path: '**',
    component: PathNotFoundComponent,
    data: { title: 'path not found' }
  },
  

]

@NgModule({
  // imports: [ RouterModule.forRoot(ROUTES, { enableTracing: !environment.production }) ],
  imports: [ RouterModule.forRoot(ROUTES, { 
    anchorScrolling: 'enabled',
    // scrollPositionRestoration: 'enabled',
    scrollPositionRestoration: 'disabled' ,
  }) ],
  // , { scrollPositionRestoration: 'enabled' }
  // imports: [ RouterModule.forRoot(ROUTES) ],

  exports: [ RouterModule ]
})

export class AppRoutingModule {}
